import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../utils/api";
import "./ServiceRequestDetail.css";

const ServiceRequestDetail = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


  const fetchRequest = useCallback(async () => {

    try {

      setLoading(true);

      const res = await api.get(`/service-requests/${id}`);

      setRequest(res.data.data);

    } catch (err) {

      console.error(err);

      setError("Unable to load service request.");

    } finally {

      setLoading(false);

    }

  }, [id]);
  
  useEffect(() => {
  fetchRequest();
}, [fetchRequest]);


  const formatDate = (date) => {

    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  };

  const getStatusClass = (status) => {

    switch ((status || "").toUpperCase()) {

      case "OPEN":
        return "badge-open";

      case "IN_PROGRESS":
        return "badge-progress";

      case "RESOLVED":
        return "badge-resolved";

      case "REJECTED":
        return "badge-rejected";

      default:
        return "badge-open";
    }

  };

  if (loading) {

    return (
      <div className="service-detail-page">
        <div className="loading-card">
          Loading service request...
        </div>
      </div>
    );

  }

  if (error) {

    return (
      <div className="service-detail-page">

        <div className="error-card">

          <h2>{error}</h2>

        </div>

      </div>
    );

  }

  return (

    <div className="service-detail-page">

      <div className="service-detail-container">

    

        <div className="detail-header">

          <div>

            <h1>{request.title}</h1>

            <p className="category">
              {request.category}
            </p>

          </div>

          <span className={`status-badge ${getStatusClass(request.status)}`}>
            {request.status}
          </span>

        </div>

        <div className="detail-card">

          <h3>Description</h3>

          <p>{request.description}</p>

        </div>

        <div className="detail-grid">

          <div className="detail-card">

            <h3>Address</h3>

            <p>{request.address || "-"}</p>

          </div>

          <div className="detail-card">

            <h3>Status</h3>

            <p>{request.status}</p>

          </div>

          <div className="detail-card">

            <h3>Created</h3>

            <p>{formatDate(request.createdAt)}</p>

          </div>

          <div className="detail-card">

            <h3>Updated</h3>

            <p>{formatDate(request.updatedAt)}</p>

          </div>

        </div>

        <div className="detail-card">

          <h3>Corporator Remarks</h3>

          <p>
            {request.corporatorRemarks
              ? request.corporatorRemarks
              : "No remarks yet."}
          </p>

        </div>

        {/* PART 2 WILL START HERE */}

        {/* ================= PROBLEM IMAGES ================= */}

<div className="image-section">

  <h3>Problem Images</h3>

  {request.images && request.images.length > 0 ? (

    <div className="image-grid">

      {request.images.map((img, index) => (

        <div className="image-card" key={index}>

          <img
            src={`${process.env.REACT_APP_API_URL || "http://localhost:8080"}${img}`}
            alt={`Problem ${index + 1}`}
            onClick={() =>
              window.open(
                `${process.env.REACT_APP_API_URL || "http://localhost:8080"}${img}`,
                "_blank"
              )
            }
          />

          <div className="image-title">
            Image {index + 1}
          </div>

        </div>

      ))}

    </div>

  ) : (

    <p>No problem images uploaded.</p>

  )}

</div>

{/* ================= RESOLUTION IMAGE ================= */}

<div className="image-section">

  <h3>Resolution Image</h3>

  {request.resolutionImage ? (

    <img
      className="resolution-image"
      src={`${process.env.REACT_APP_API_URL || "http://localhost:8080"}${request.resolutionImage}`}
      alt="Resolution"
      onClick={() =>
        window.open(
          `${process.env.REACT_APP_API_URL || "http://localhost:8080"}${request.resolutionImage}`,
          "_blank"
        )
      }
    />

  ) : (

    <p>Resolution image not available.</p>

  )}

</div>

{/* ================= ACTION BUTTONS ================= */}

<div className="detail-buttons">

 <button
    className="service-btn-back"
    onClick={() => navigate("/my-service-requests")}
>
    ← Back to My Requests
</button>

<button
    className="service-btn-dashboard"
    onClick={() => navigate("/dashboard")}
>
    Dashboard
</button>

</div>

      </div>

    </div>

  );

};

export default ServiceRequestDetail;